export enum OrderState
{
    InProgress = 0,
    Expired = 1,
    Completed = 2
}
